import { products } from '@picsio/db/src/constants';

/** Shopify product string field cap — shared with server via @picsio/db products.fieldMaxLength */
export const PRODUCT_FIELD_MAX_LENGTH = products.fieldMaxLength;

export const SEO_TITLE_RECOMMENDED_LENGTH = 70;

export const SEO_DESCRIPTION_RECOMMENDED_LENGTH = 160;

/** Hard storage cap for SEO fields — shared with server via @picsio/db */
export const SEO_TITLE_MAX_LENGTH = products.seoTitleMaxLength;

export const SEO_DESCRIPTION_MAX_LENGTH = products.seoDescriptionMaxLength;

export const productFieldInputProps = {
  maxLength: PRODUCT_FIELD_MAX_LENGTH,
};
